import { render, staticRenderFns } from "./project_filter.vue?vue&type=template&id=848fa8c8&"
import script from "./project_filter.vue?vue&type=script&lang=js&"
export * from "./project_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports